export const renderDuration = (duration: number) => {
    let minutes = Math.floor(duration) / 60;
    const hours = Math.floor(minutes / 60);
    minutes = minutes - (hours * 60);

    return duration === 0 ? "0 m" : `
        ${hours > 0 ? hours : ""} ${hours > 0 ? "h" : ""} 
        ${minutes > 0 ? Math.floor(minutes) : ""} ${minutes > 0 ? "m" : ""}
    `;
}
